import { render, staticRenderFns } from "./cooperativegoods.vue?vue&type=template&id=4c1bf9cc&scoped=true"
import script from "./cooperativegoods.vue?vue&type=script&lang=js"
export * from "./cooperativegoods.vue?vue&type=script&lang=js"
import style0 from "./cooperativegoods.vue?vue&type=style&index=0&id=4c1bf9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1bf9cc",
  null
  
)

export default component.exports